var isHeaderSticky = false;

$((readyEvent) => {
  $(window).on("scroll", null, function (scrollEvent) {
    isHeaderSticky = $(document).scrollTop() >= 100;
    updateHeader();
  });
});

const updateHeader = () => {
  if (isHeaderSticky) {
    if (!$("header nav").hasClass("sticky")) {
      $("header nav").addClass("sticky");
    }
  } else {
    if ($("header nav").hasClass("sticky")) {
      $("header nav").removeClass("sticky");
    }
  }
};
